<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App' 
}
</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
      /*border: 1px solid red; */
  /*background-image: url('/static/img/bg-reception.jpg');*/
  /*background-image: linear-gradient( rgba(96,96,96, 0.2), rgba(96,96,96, 0.2)), url('/static/img/bg2.jpg'); */
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/App.vue